import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CustomBox } from '../../../components/Tutor/style';
import InputLegend from '../../InputLegend';
import CustomTextarea from '../../CustomTextarea';
import CTA from '../../CTA';
import Answer from './Answer';
import {
  ADD_ANSWER,
  DEL_QUESTION,
  UPDATE_QUESTION,
} from '../../../../app/redux/actions/tutors';

const Question = ({
  index,
  delQuestion,
  updateQuesion,
  questionKey,
  quiz,
  addAnswer,
  editMode,
}) => {
  const question = quiz[questionKey] || {};

  useEffect(() => {
    if (questionKey && !editMode) addAnswer(questionKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CustomBox className="mb-4">
      <div className="d-flex sb mb-3">
        <InputLegend label={`Domanda ${index}`} required mb={0} htmlFor="quiz-question" />
        {index > 1 && (
          <CTA
            type="tertiary"
            btnText="Elimina"
            icon="trash-01"
            onClick={() => delQuestion(questionKey)}
          />
        )}
      </div>
      <CustomTextarea
        placeholder="Inserisci la domanda"
        id="quiz-question"
        minHeight={65}
        fixed
        onChange={(value) => updateQuesion(questionKey, 'question', value)}
        value={question?.question}
      />
      {Object.keys(question?.choice_answers || {}).map((k, i) => (
        <Answer
          key={`answer-${questionKey}-${i}`}
          index={i + 1}
          questionKey={questionKey}
          answerKey={k}
        />
      ))}
      <CTA
        type="tertiary"
        btnText="Aggiungi risposta"
        icon="plus"
        onClick={() => addAnswer(questionKey)}
      />
    </CustomBox>
  );
};

Question.propTypes = {
  index: PropTypes.number,
  quiz: PropTypes.object,
  questionKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  updateQuesion: PropTypes.func,
  delQuestion: PropTypes.func,
  addAnswer: PropTypes.func,
  editMode: PropTypes.func,
};

export default connect(
  (state) => {
    const { quiz } = state.tutors.quiz;
    return { quiz };
  },
  (dispatch) => ({
    delQuestion: (id) => dispatch({ type: DEL_QUESTION, id }),
    updateQuesion: (id, field, value) =>
      dispatch({ type: UPDATE_QUESTION, id, field, value }),
    addAnswer: (questionId) => dispatch({ type: ADD_ANSWER, questionId }),
  })
)(Question);
